import { inject, Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { LoggerService } from "./logger.service";

@Injectable()
export class GeneralToastOptions {
    animate = "fade";
    maxShown = 3;
    showCloseButton = false;
    toastLife = 8000;
    dismiss = "click";
}

@Injectable()
export class NotificationService {
    private logger = inject(LoggerService);

    constructor(private toastr: ToastrService) {}

    error(action: string, msg: string): void {
        this.logger.error("%s: %s", action, msg);
        this.toastr.error(msg, action, {
            disableTimeOut: true,
        });
    }

    errorExt(
        action: string,
        msg: string,
        error: string | HttpErrorResponse | TypeError,
    ) {
        let details = "";
        if (typeof error === "string") {
            details = error;
        } else if (error instanceof HttpErrorResponse) {
            switch (error.status) {
                case 0:
                case -1:
                    msg +=
                        " Die Anfrage wurde Client-Seitig beendet. Bitte prüfen Sie die Internetverbindung und versuchen Sie es anschließend erneut.";
                    break;
                case 401:
                    msg += " Sie sind nicht angemeldet.";
                    break;
                case 403:
                    msg += " Sie haben nicht die nötigen Berechtigungen.";
                    break;
            }
            if (error.error && error.error.error && error.error.error.message) {
                switch (error.status) {
                    case 400:
                        msg += " Die Anfrage ist fehlerhaft.";
                        break;
                    case 404:
                        msg +=
                            " Der Eintrag existiert nicht oder Sie haben nicht die benötigten Rechte.";
                        break;
                    case 500:
                        msg += " Ein interner Fehler ist aufgetreten.";
                        break;
                }
                details = error.error.error.message;
            } else {
                switch (error.status) {
                    case 404:
                        msg += " Möglicherweise läuft ein Backend nicht.";
                        break;
                }
                details = error.message;
            }
        } else if (error instanceof TypeError) {
            details = `${error.message}`;
        } else {
            this.logger.log("Unknown error: %s", error);
        }
        // let text: string = `${msg}<div class='error-details'><span class='title'>Technische Details: </span>${details}`
        const text: string = details
            ? `${msg} Technische Details: ${details}`
            : msg;
        this.logger.error("%s: %s\n%s", action, text, details);
        this.toastr.error(text, action, { disableTimeOut: true }); //, { enableHTML: true })
    }

    warning(action: string, msg: string) {
        this.logger.warn("%s: %s", action, msg);
        this.toastr.warning(msg, action);
    }

    info(action: string, msg: string): void {
        this.toastr.info(msg, action);
    }

    clear() {
        this.toastr.clear();
    }
}
